import type { TranslationFunction } from '../../translations/Translation';
import { CHILDREN_FREE_OFFER_PROMOTION_TYPE } from './childrenFreeOffer';

// Product decision: for the promotion types listed here we render OUR own copy and ignore the
// provider-supplied `label`, which is inconsistent across providers (e.g. shdapi sends
// "Children free offer" for the kids-stay-free promotion). The map is keyed by the API `type`
// (uppercased) so overriding another provider badge is a one-line addition. Promotion types not
// listed here keep the provider `label` as the fallback.
const PROMOTION_TYPE_TO_I18N_KEY: Readonly<Record<string, string>> = {
  [CHILDREN_FREE_OFFER_PROMOTION_TYPE]: 'vacation.oss.cards.badgets.childrenstayfree',
};

export const getPromotionLabel = (
  promotion: Pick<MealPlanPromotion, 'type' | 'label'> | undefined,
  t: TranslationFunction
): string => {
  if (!promotion) return '';
  const i18nKey = PROMOTION_TYPE_TO_I18N_KEY[promotion.type?.toUpperCase() ?? ''];
  return i18nKey ? t(i18nKey) : promotion.label;
};
